import { render, staticRenderFns } from "./BannerAd.vue?vue&type=template&id=71cf0bbe&scoped=true&"
import script from "./BannerAd.vue?vue&type=script&lang=js&"
export * from "./BannerAd.vue?vue&type=script&lang=js&"
import style0 from "./BannerAd.vue?vue&type=style&index=0&id=71cf0bbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf0bbe",
  null
  
)

export default component.exports